import { Module } from 'vuex'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import RootState from '@vue-storefront/core/types/RootState'
import TagsState from '../../types/TagsState'

export const tagsModule: Module<TagsState, RootState> = {
  namespaced: true,
  state: {
    tags: [],
    selected_tags: [],
    loadedFor: null
  },
  getters,
  actions,
  mutations
}
